export default "__VITE_ASSET__da7df7ef__"